function initAnnouncementSlider() {
    var swiper = new Swiper(".M-announcement-slider", {
      autoplay: true,
       speed: 500,
      loop: true, 
      slidesPerView: 1
    });
  }